import { jsx as _jsx } from "react/jsx-runtime";
import { Box, Icon, useMultiStyleConfig } from '@chakra-ui/react';
import { dataAttr } from '@chakra-ui/utils';
import { BxCheckAnimated } from '../../../icons';
export const ItemCheckboxIcon = ({ isChecked, isDisabled, size, sx, }) => {
    const styles = useMultiStyleConfig('Checkbox', { size });
    return (_jsx(Box, { userSelect: "none", __css: styles.control, "data-checked": dataAttr(isChecked), sx: sx, "aria-disabled": isDisabled, children: _jsx(Icon, { as: BxCheckAnimated, __css: styles.icon, isChecked: isChecked }) }));
};
